import { useCallback } from 'react';
import { Sizes } from 'enums/sizes';
import { useDialog } from 'hooks/useDialog';
import { useAbp } from 'core/hooks/useAbp';
import { AbpPolicies } from 'core/constants/AbpPolicies';
import { TunnelActionTarget } from '../tunnelActionTarget';
import { DeleteTunnelModal } from './DeleteTunnelModal';

/**
 * Ouverture de la confirmation de suppression, partagée par la liste admin et la fiche.
 * Aucune condition sur le tunnel lui-même — actif ou non, référencé ou non, l'action est
 * proposée et c'est le back qui refuse en expliquant. Seule la permission conditionne
 * l'affichage, pour ne pas offrir un bouton qui ne rendrait qu'un 403 muet.
 */
export const useDeleteTunnelDialog = () => {
  const { openBlankDialog } = useDialog();
  const { hasPermission } = useAbp();

  const canDelete = hasPermission(AbpPolicies.ADMIN_TUNNELS_DELETE);

  const openDeleteDialog = useCallback(
    (tunnel: TunnelActionTarget, onDeleted?: () => void) =>
      openBlankDialog(
        { size: Sizes.xl },
        <DeleteTunnelModal tunnel={tunnel} onDeleted={onDeleted} />
      ),
    [openBlankDialog]
  );

  return { canDelete, openDeleteDialog };
};
